import {Link} from 'react-router-dom';
import {Button, Message} from 'semantic-ui-react';

function MobileVerificationMessage() {
  return (
    <Message error className='text-center'>
      <p>شماره تلفن همراه شما تایید نشده است،</p>
      <p>لطفا برای جلوگیری از مشکلات احتمالی در ورود به سایت شماره تلفن خود را تایید کنید.</p>

      <Button basic positive as={Link} to='/profile/mobile-verification' content='تایید شماره تلفن همراه'/>
      <Button basic primary as={Link} to='/profile/update-mobile' content='تغییر شماره تلفن همراه'/>
    </Message>
  );
}

export default MobileVerificationMessage;
